import { useFormShowContext } from 'framework/form';
import { Box, Typography } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';
import { ACCESS_INFO_ACTIONS, ACCESS_INFO_SECTIONS, useProjectSecurityContext } from 'domain/shared/newProject';

const EmptyTeamSection = () => {
  const { toggleEditMode } = useFormShowContext();
  const { isAccessGranted } = useProjectSecurityContext();

  return (
    <Box mb="10px">
      <Typography display="flex" alignItems="center" color="textSecondary">
        The team for this project has not been created.{' '}
        {isAccessGranted(ACCESS_INFO_SECTIONS.TEAM, ACCESS_INFO_ACTIONS.MANAGE) ? (
          <>
            You can
            <Button onClick={toggleEditMode} sx={{ ml: '5px' }} link>
              сreate a team.
            </Button>
          </>
        ) : null}
      </Typography>
    </Box>
  );
};

export default EmptyTeamSection;
